import { Component, OnInit, ViewChild, Inject, ElementRef } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { RouterModule } from '@angular/router';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { query } from '@angular/animations';
// import { SupplierInvoiceComponent } from '../supplier-invoice/supplier-invoice.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-supplier-invoice-list',
  templateUrl: './supplier-invoice-list.component.html',
  styleUrls: ['./supplier-invoice-list.component.css']
})
export class SupplierInvoiceListComponent implements OnInit {

  public menu_item_id = '19';
  public add_auth;
  public edit_auth;
  public del_auth;
  private dp = [];

  // types = [{ 'type_ar': 'الكل', 'type_en': 'all' }, { 'type_ar': 'فاتورة مشتريات', 'type_en': 'supplier_invoice' },
  // { 'type_ar': 'مرتجع مشتريات', 'type_en': 'return_supplier_invoice' }];

  delivere = [{ 'delivered_ar': 'الكل', 'delivered_en': 'all' }, { 'delivered_ar': 'تم الاستلام', 'delivered_en': '1' },
  { 'delivered_ar': 'لم يتم الاستلام', 'delivered_en': '0' }];

  displayedColumns = ['invoice_no', 'supplier_invoice_no', 'invoice_date', 'supplier_name', 'mobile',
    'total', 'inv_status', 'branch_name', 'comment', 'created_by', 'detail', 'print', 'return', 'edit', 'del'];   // , 'type'
  
  displayedColumns2 = ['invoice_no', 'supplier_invoice_no', 'invoice_date', 'supplier_name', 'mobile',
    'total', 'inv_status', 'branch_name', 'comment', 'created_by'];   // , 'type'
  dataSource = new MatTableDataSource(this.dp);
  // addDialogRef: MatDialogRef<SupplierInvoiceComponent>; , public dialog: MatDialog
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('TABLE') table: ElementRef;

  model = {
    'table_name': 'supplier_invoice', 'invoice_no': '', 'from_date': new Date(),
    'to_date': new Date(), 'supplier_name': '', 'mobile': '', 'type': 'all', 'delivered': 'all',
    'branch_id': '0', 'title': 'فواتير المشتريات'
  };

  branchList = [];

  Supplier_Invoices; Return_Supplier_Invoices; Not_Delivered; Delivered;
  Supplier_Invoice; Return_Supplier_Invoice; From_Date; To_Date; All;
  Success_Msg; Error_Msg; Del_Msg; Invoice_No; Supplier_Name; Type; Mobile; Status;

  constructor(private utils: Utils, private applicationConstants: ApplicationConstants,
    private queryList: QueryList, public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    // translate.get('All').subscribe((res: string) => {
    //   this.All = res;
    // });
    // this.types['0']['type_ar'] = this.All;
    // this.delivere['0']['delivered_ar'] = this.All;

    translate.get('Supplier_Invoices').subscribe((res: string) => {
      this.Supplier_Invoices = res;
    });
    // this.types['1']['type_ar'] = this.Supplier_Invoices;
    this.model['title'] = this.Supplier_Invoices;

    // translate.get('Return_Supplier_Invoices').subscribe((res: string) => {
    //   this.Return_Supplier_Invoices = res;
    // });
    // this.types['2']['type_ar'] = this.Return_Supplier_Invoices;

    translate.get('Supplier_Invoice').subscribe((res: string) => {
      this.Supplier_Invoice = res;
    });

    translate.get('Return_Supplier_Invoice').subscribe((res: string) => {
      this.Return_Supplier_Invoice = res;
    });

    translate.get('From_Date').subscribe((res: string) => {
      this.From_Date = res;
    });

    translate.get('To_Date').subscribe((res: string) => {
      this.To_Date = res;
    });

    // translate.get('Delivered').subscribe((res: string) => {
    //   this.Delivered = res;
    // });
    // this.delivere['1']['delivered_ar'] = this.Delivered;

    // translate.get('Not_Delivered').subscribe((res: string) => {
    //   this.Not_Delivered = res;
    // });
    // this.delivere['2']['delivered_ar'] = this.Not_Delivered;

    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });

    translate.get('Del_Msg').subscribe((res: string) => {
      this.Del_Msg = res;
    });

    translate.get('Invoice_No').subscribe((res: string) => {
      this.Invoice_No = res;
    });

    translate.get('Supplier_Name').subscribe((res: string) => {
      this.Supplier_Name = res;
    });

    translate.get('Type').subscribe((res: string) => {
      this.Type = res;
    });

    translate.get('Mobile').subscribe((res: string) => {
      this.Mobile = res;
    });

    translate.get('Status').subscribe((res: string) => {
      this.Status = res;
    });
  }


  ngOnInit() {
    this.add_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.ADD_AUTH);
    this.edit_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.EDIT_AUTH);
    this.del_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.DELETE_AUTH);

    // this.model['branch_id'] = this.applicationConstants.user_branch_info.user_branch_id;
    
    let query = "SELECT DISTINCT `branch`.* FROM `branch`, `branch_auth` WHERE `branch_auth`.`branch_id` =" +
      " `branch`.`branch_id` AND `branch`.`status` = '1' AND `branch_auth`.`status` = '1'" +
      " AND `branch_auth`.`user_id` = '" + this.applicationConstants.user_info.user_id + "'";
    let obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();

        this.branchList = data.data['list'];
        this.branchList.unshift({ 'branch_id': '0', 'branch_name': 'الكل', 'branch_name_en': 'All' });
      });

    // this.model['from_date'] = undefined;
    // this.model['to_date'] = undefined;
  }

  search() {
    ///////////////////// supplier_invoice //////////////////////
    let condition = '';
    let query, obj;

    // let from_date = this.model['from_date'].getFullYear() + "-" + (this.model['from_date'].getMonth() + 1) + "-" +
    //   this.model['from_date'].getDate();
    // let to_date = this.model['to_date'].getFullYear() + "-" + (this.model['to_date'].getMonth() + 1) + "-" +
    //   this.model['to_date'].getDate();

    // if (this.model['type'] == 'all' || this.model['type'] == 'supplier_invoice' || this.model['type'] == '') {

      //condition = " AND `supplier_invoice`.`invoice_date` BETWEEN '" + from_date + "' AND '" + to_date + "' ";

      // if (this.model['from_date'] != undefined && this.model['to_date'] != undefined) {


      //   if (this.model['from_date'] == this.model['to_date'])
      //     condition += " AND `supplier_invoice`.`invoice_date` = '" + from_date + "'";
      //   else
      //     condition += " AND `supplier_invoice`.`invoice_date` BETWEEN '" + from_date + "' AND '" + to_date + "'";
      // }

    if (this.model['from_date'] != undefined) {
      let from_date = (this.model['from_date'].getFullYear() + "-" + (this.model['from_date'].getMonth() + 1)
        + "-" + this.model['from_date'].getDate() + ' 00:00:00');
      condition += " AND `supplier_invoice`.`invoice_date` >= '" + from_date + "'";
    }
    if (this.model['to_date'] != undefined) {
      let to_date = (this.model['to_date'].getFullYear() + "-" + (this.model['to_date'].getMonth() + 1)
        + "-" + this.model['to_date'].getDate() + ' 23:59:59');;
      condition += " AND `supplier_invoice`.`invoice_date` <= '" + to_date + "'";
    }

    if (this.model['invoice_no'] != '')
      condition = " AND `supplier_invoice`.`invoice_no` LIKE '%" + this.model['invoice_no'] + "%'";

    if (this.model['supplier_name'] != '')
      condition += " AND (`supplier`.`supplier_name` LIKE '%" + this.model['supplier_name'] + "%' OR `supplier`.`supplier_name_en` LIKE '%" + this.model['supplier_name'] + "%')";

    if (this.model['mobile'] != '')
      condition += " AND `supplier`.`mobile` LIKE '%" + this.model['mobile'] + "%'";

    if (this.model['delivered'] != 'all' && this.model['delivered'] != '')
      condition += " AND `supplier_invoice`.`received` ='" + this.model['delivered'] + "'";

    if (this.model['branch_id'] != '0')
      condition += " AND `supplier_invoice`.`branch_id` = '" + this.model['branch_id'] + "'";

    else if (this.model['branch_id'] == '0') {
      let index = 1;
      let list_length = this.branchList.length;

      if (list_length == 2) 
        condition += " AND `supplier_invoice`.`branch_id` = '" + this.branchList[1]['branch_id'] + "'";
      else {
        condition += " AND `supplier_invoice`.`branch_id` IN (";
        this.branchList.forEach(element => {
          if (element.branch_id != '0') {
            if (index < list_length)
              condition += " '" + element.branch_id + "',";
            else if (index == list_length)
              condition += " '" + element.branch_id + "'";
          }
          index++;
        });
        condition += ")";
      }
    }

    condition += "  AND `supplier_invoice`.`status` != '0' ";

    query = "SELECT `supplier_invoice`.*, (`supplier_invoice`.`amount` + `supplier_invoice`.`tax` - " + 
      "`supplier_invoice`.`discount` + `supplier_invoice`.`transport_fee`) AS 'total', `supplier`.`acct_number`, " +
      "`supplier`.`supplier_name`, `supplier`.`supplier_name_en`, `supplier`.`mobile`, `employee`.`name`, " +
      "`employee`.`name_en`, `branch`.`branch_name`, `branch`.`branch_name_en` FROM `supplier_invoice`, " + 
      "`supplier`, `user`, `employee`, `branch` WHERE `supplier_invoice`.`supplier_no` = `supplier`.`acct_number`" + 
      " AND `supplier_invoice`.`created_by` = `user`.`user_name` AND `user`.`employee_no` = `employee`.`employee_no`" + 
      " AND `supplier_invoice`.`branch_id` = `branch`.`branch_id`" + condition;
      // " AND `supplier_invoice`.`branch_id` = '" + this.applicationConstants.user_branch_info.user_branch_id + "'" + condition;
      // '" + this.Supplier_Invoice + "' AS 'type'
    // console.log(query);
    obj = { cmd: 'getList', query: query };

    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();

        this.dp = data.data['list'];
        this.dp.forEach(element => {
          element.invoice_date = (element.invoice_date).substring(0, 10);
          element.total = this.utils.numberFormat(Number(element.total));

          if (element.received == '1') {
            element.inv_status = this.delivere[1].delivered_ar;
            element.inv_status_en = this.delivere[1].delivered_en;
          }
          else {
            element.inv_status = this.delivere[2].delivered_ar;
            element.inv_status_en = this.delivere[2].delivered_en;
          }
        });
        this.dataSource = new MatTableDataSource(this.dp);
        this.dataSource.sort = this.sort;
      });
    // }

    ///////////////////// return_supplier_invoice //////////////////////

    // if (this.model['type'] == 'all' || this.model['type'] == 'return_supplier_invoice' || this.model['type'] == '') {

    //   condition = " AND `return_supplier_invoice`.`status` != '0'";


      // if (this.model['from_date'] != undefined && this.model['to_date'] != undefined) {

      //   let from_date = this.model['from_date'].getFullYear() + "-" + (this.model['from_date'].getMonth() + 1) + "-" + this.model['from_date'].getDate();
      //   let to_date = this.model['to_date'].getFullYear() + "-" + (this.model['to_date'].getMonth() + 1) + "-" + this.model['to_date'].getDate();

      //   if (this.model['from_date'] == this.model['to_date'])
      //     condition += " AND `return_supplier_invoice`.`return_date` = '" + from_date + "'";
      //   else
      //     condition += " AND `return_supplier_invoice`.`return_date` BETWEEN '" + from_date + "' AND '" + to_date + "'";
      // }

    //   if (this.model['from_date'] != undefined) {
    //     let from_date = this.model['from_date'].getFullYear() + "-" + (this.model['from_date'].getMonth() + 1) + "-" + this.model['from_date'].getDate();
    //     condition += " AND `return_supplier_invoice`.`return_date` >= '" + from_date + "'";
    //   }
    //   if (this.model['to_date'] != undefined) {
    //     let to_date = this.model['to_date'].getFullYear() + "-" + (this.model['to_date'].getMonth() + 1) + "-" + this.model['to_date'].getDate();
    //     condition += " AND `return_supplier_invoice`.`return_date` <= '" + to_date + "'";
    //   }

    //   if (this.model['invoice_no'] != '')
    //     condition = " AND `return_supplier_invoice`.`invoice_no` LIKE '%" + this.model['invoice_no'] + "%'";

    //   if (this.model['supplier_name'] != '')
    //     condition += " AND `supplier`.`supplier_name` LIKE '%" + this.model['supplier_name'] + "%'";

    //   if (this.model['mobile'] != '')
    //     condition += " AND `supplier`.`mobile` LIKE '%" + this.model['mobile'] + "%'";

    //   if (this.model['branch_id'] != '0')
    //     condition += " AND `return_supplier_invoice`.`branch_id` = '" + this.model['branch_id'] + "'";

    //   else if (this.model['branch_id'] == '0') {
    //     let index = 1;
    //     let list_length = this.branchList.length;

    //     condition += " AND `return_supplier_invoice`.`branch_id` IN (";
    //     this.branchList.forEach(element => {
    //       if (element.branch_id != '0') {
    //         if (index < list_length)
    //           condition += " '" + element.branch_id + "',";
    //         else if (index == list_length)
    //           condition += " '" + element.branch_id + "'";
    //       }
    //       index++;
    //     });
    //     condition += ")";
    //   }


    //   query = "SELECT `return_supplier_invoice`.*, `return_supplier_invoice`.`return_date` AS 'invoice_date'," +
    //     " `return_supplier_invoice`.`total`, `supplier`.`acct_number`, `supplier`.`supplier_name`, '" +
    //     this.Return_Supplier_Invoice + "' AS 'type', `return_supplier_invoice_no` AS 'invoice_no' FROM `return_supplier_invoice`," +
    //     " `supplier` WHERE `supplier`.`acct_number` = `return_supplier_invoice`.`supplier_no`  " +
    //     " AND `return_supplier_invoice`.`branch_id` = '" + this.applicationConstants.user_branch_info.user_branch_id + "'" + condition;
    //   // console.log(query);
    //   obj = { cmd: 'getList', query: query };

    //   this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
    //     .subscribe(data => {
    //       this.applicationConstants.appComp.hideBusyCursor();
    //       if (data.data['list'].length > 0) {
    //         data.data['list'].forEach(element => {
    //           element.invoice_date = (element.invoice_date).substring(0, 10);
    //           element.total = this.utils.numberFormat(Number(element.total));
    //           this.dp.push(element);
    //         });
    //         // this.dp.push(data.data['list']);
    //         // this.dp = data.data['list'];
    //         this.dataSource = new MatTableDataSource(this.dp);
    //         this.dataSource.sort = this.sort;
    //       }

    //     });

    // }

    ///////////////////// all //////////////////////

    // else if (this.model['type'] == '') {

    //   let condition1 = "";
    //   let condition2 = "";

    //   if (this.model['from_date'] != undefined && this.model['to_date'] != undefined) {

    //     let from_date = this.model['from_date'].getFullYear() + "-" + (this.model['from_date'].getMonth() + 1) + "-" + this.model['from_date'].getDate();
    //     let to_date = this.model['to_date'].getFullYear() + "-" + (this.model['to_date'].getMonth() + 1) + "-" + this.model['to_date'].getDate();

    //     if (this.model['from_date'] == this.model['to_date']) {
    //       condition1 += " AND `supplier_invoice`.`invoice_date` = '" + from_date + "'";
    //       condition2 += " AND `return_supplier_invoice`.`return_date` = '" + from_date + "'";
    //     }
    //     else {
    //       condition1 += " AND `supplier_invoice`.`invoice_date` BETWEEN '" + from_date + "' AND '" + to_date + "'";
    //       condition2 += " AND `return_supplier_invoice`.`return_date` BETWEEN '" + from_date + "' AND '" + to_date + "'";
    //     }
    //   }

    //   else if (this.model['from_date'] != undefined && this.model['to_date'] == undefined) {
    //     let from_date = this.model['from_date'].getFullYear() + "-" + (this.model['from_date'].getMonth() + 1) + "-" + this.model['from_date'].getDate();
    //     condition1 += " AND `supplier_invoice`.`invoice_date` >= '" + from_date + "'";
    //     condition2 += " AND `return_supplier_invoice`.`return_date` >= '" + from_date + "'";
    //   }
    //   else if (this.model['from_date'] == undefined && this.model['to_date'] != undefined) {
    //     let to_date = this.model['to_date'].getFullYear() + "-" + (this.model['to_date'].getMonth() + 1) + "-" + this.model['to_date'].getDate();
    //     condition1 += " AND `supplier_invoice`.`invoice_date` <= '" + to_date + "'";
    //     condition2 += " AND `return_supplier_invoice`.`return_date` <= '" + to_date + "'";
    //   }

    //   if (this.model['supplier_invoice_no'] != '') {
    //     condition1 += " AND `supplier_invoice`.`supplier_invoice_no` LIKE '%" + this.model['supplier_invoice_no'] + "%'";
    //     condition2 += " AND `return_supplier_invoice`.`supplier_invoice_no` LIKE '%" + this.model['supplier_invoice_no'] + "%'";
    //   }

    //   if (this.model['supplier_name'] != '') {
    //     condition1 += " AND `supplier`.`supplier_name` LIKE '%" + this.model['supplier_name'] + "%'";
    //     condition2 += " AND `supplier`.`supplier_name` LIKE '%" + this.model['supplier_name'] + "%'";
    //   }

    //   if (this.model['mobile'] != '') {
    //     condition1 += " AND `supplier`.`mobile` LIKE '%" + this.model['mobile'] + "%'";
    //     condition2 += " AND `supplier`.`mobile` LIKE '%" + this.model['mobile'] + "%'";
    //   }

    //   if (this.model['delivered'] != '')
    //     condition1 += " AND `supplier_invoice`.`delivered` ='" + this.model['delivered'] + "'";


    //   let query = "(SELECT `supplier_invoice`.`supplier_invoice_no`, `supplier_invoice`.`invoice_date`, " +
    //     " `supplier_invoice`.`amount`, `supplier`.`supplier_id`, `supplier`.`supplier_name`, 'فاتورة مشتريات' AS 'type' FROM `supplier_invoice`," +
    //     " `supplier` WHERE `supplier`.`supplier_no` = `supplier_invoice`.`supplier_no` AND `supplier_invoice`.`status` = '1'" + condition1 +
    //     ") UNION (SELECT `return_supplier_invoice`.`return_supplier_invoice_no`, `return_supplier_invoice`.`return_date` AS 'invoice_date'," +
    //     " `return_supplier_invoice`.`total` AS 'amount', `supplier`.`supplier_id`, `supplier`.`supplier_name`, " +
    //     "'مرتجع مشتريات' AS 'type' FROM `return_supplier_invoice`, `supplier` WHERE " +
    //     "`supplier`.`supplier_id` = `return_supplier_invoice`.`supplier_id` AND `return_supplier_invoice`.`status` = '1'" + condition2 + ")";

    //   let obj = { cmd: 'getList', query: query };

    //   this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
    //     .subscribe(data => {
    //       this.dp = data.data['list'];
    //       this.dataSource = new MatTableDataSource(this.dp);
    //       this.dataSource.sort = this.sort;
    //     });

    // }

    // this.model = {
    //   'table_name': 'supplier_invoice', 'supplier_invoice_no': '', 'from_date': undefined,
    //   'to_date': undefined, 'supplier_name': '', 'mobile': '', 'type': '', 'delivered': ''
    // };

  }

  // newInv() {
  //   this.addDialogRef = this.dialog.open(SupplierInvoiceComponent, {
  //     hasBackdrop: false,
  //   });
  //   this.addDialogRef
  //     .afterClosed()
  //     .subscribe(result => {
  //     });
  // }

  print(invoice_no = null) {

    if (invoice_no == null) {
      let html_data = '';
      let form = (document.getElementById('form1') as HTMLFormElement);
      let from_date = '';
      let to_date = '';
      if (this.model['from_date'] != undefined)
        from_date = this.model['from_date'].getFullYear() + "-" +
          (this.model['from_date'].getMonth() + 1) + "-" + this.model['from_date'].getDate();
      if (this.model['to_date'] != undefined)
        to_date = this.model['to_date'].getFullYear() + "-" +
          (this.model['to_date'].getMonth() + 1) + "-" + this.model['to_date'].getDate();

      html_data = '<table cellpadding="8" cellspacing="0">';
      html_data += '<tr><td width="33%"> ' + this.From_Date + ': ' + from_date + '</td>';
      html_data += '<td width="33%"> ' + this.To_Date + ': ' + to_date + ' </td>';
      html_data += '<td width="33%"> ' + this.Status + ': ';
      this.delivere.forEach(element => {
        if (element.delivered_en == this.model['delivered']) {
          html_data += element.delivered_ar;
          return;
        }
      });
      html_data += '</td></tr>';

      html_data += '<tr><td width="33%"> ' + this.Invoice_No + ': ' + this.model['invoice_no'] + '</td>';
      html_data += '<td width="33%"> ' + this.Supplier_Name + ': ' + this.model['supplier_name'] + ' </td>';
      html_data += '<td width="33%"> ' + this.Mobile + ': ' + this.model['mobile'] + '</td></tr>';
      // html_data += '<tr><td width="33%"> ' + this.Type + ': ';
      // this.types.forEach(element => {
      //   if (element.type_en == this.model['type']) {
      //     html_data += element.type_ar;
      //     return;
      //   }
      // });
      // html_data += '</td>';
      // html_data += '<td width="33%"> ' + this.Status + ': ';
      // this.delivere.forEach(element => {
      //   if (element.delivered_en == this.model['delivered']) {
      //     html_data += element.delivered_ar;
      //     return;
      //   }
      // });
      // html_data += '</td>';
      // html_data += '<td width="33%"></td></tr>';
      html_data += '</table>';

      let table = (document.getElementById('sup_inv_table2') as HTMLTableElement);
      html_data += this.utils.printReport(html_data, [{ table: table }], form, 'PDF');
    }
    else
      window.open(this.applicationConstants.generatePDF + "?type=supplier_invoice&no=" + invoice_no, "_blank");
  }

  delSupInv(row) {
    if (confirm(this.Del_Msg)) {
      let values = [{ 'table_name': this.model['table_name'], 'invoice_no': row.invoice_no }];
      values.push({ 'table_name': 'supplier_invoice_item', 'invoice_no': row.invoice_no });
      values.push({ 'table_name': 'supp_inv_payment_method', 'invoice_no': row.invoice_no });
      values.push({ 'table_name': 'stock', 'invoice_no': row.invoice_no });
      values.push({ 'table_name': 'stock_base', 'invoice_no': row.invoice_no });

      let obj = { cmd: 'deleteRec', values: values };
      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();

          console.log(data);
          if (data.status['type'] == 'success') {
            alert(this.Success_Msg);
            this.search();
          }
          else {
            alert(this.Error_Msg);
          }
        });
    }
  }

  exportToExcel() {
    this.utils.exportToExcel(this.table.nativeElement, this.model.title);
  }

}
